module.exports = __webpack_public_path__ + "img/code.67565f38.png";